(function () {
    'use strict';

    function titleCase() {
        return function (value) {
            return Humanize.titleCase(value.replace(/([A-Z])/g, ' $1'));
        };
    }

    angular.module('ecap.common').filter('titleCase', titleCase);
})();